// Dashboard Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

export const updateSidebarSubMenu = ({ commit }, payload) => {
  commit('updateCurrentSubLinks', payload)
  commit('toggleSidebarSubMenu', true)
}

export const showSidebarSubMenu = ({ commit }) => {
  commit('toggleSidebarSubMenu', true)
}

export const closeSidebarSubMenu = ({ commit }) => {
  commit('closeSidebarSubMenu')
}

export const setAppBarTitle = ({ commit }, payload) => {
  commit('updateAppBarTitle', payload)
}

// ***** Fetch Cash & Cashier balance from backend ***** //
export const fetchCashBalance = async ({ commit }) => {
  try {
    const result = await Axios.get(`cash_balance_show`)
    commit('updateCashBalance', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch Cash & Cashier balance from backend ***** //
export const fetchAllBalance = async ({ commit }) => {
  try {
    const result = await Axios.get(`show_total_cash_balance`)
    commit('setAllBalance', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** update share price from backend ***** //
export const updateSharePrice = async (ignored, payload = null) => {
  try {
    await Axios.post(`cash_balance_update`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}
